import type { PaletteColorOptions } from "@mui/material";

const mainColor = "#003250";

export const primaryLight: PaletteColorOptions = {
  main: mainColor,
  light: "#00547E",
  dark: "#00243A",
  contrastText: "#FFF",
};

export const primaryDark: PaletteColorOptions = {
  main: "#004ba0",
  light: "#63a4ff",
  dark: "#004ba0",
  contrastText: "#fff",
};
